import api from '@/services/axios'
import store from '@/store/index'

export default {
  async auth(to, from, next) {
    await api.get('/auth/me').then((response) => {
      store.commit('setUser', response.data.user);
      next() 
    })
    .catch(() => {
      next({
          path: '/login'
      })
    })
  },

  async admin(to, from, next) {
    await api.get('/auth/me').then((response) => {

      if(response.data.user.is_admin == true) {
        next() 
      } else {
        next({
          path: '/login'
        })
      }
      
    })
    .catch(() => {
      next({
          path: '/login'
      })
    })
  }
}